// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills-bar {
  width: 100%;
}

.bar {
  margin-top: 8px;
}

.bar_one {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.skills-box {
  margin-top: 30px;
}

.skills-box .bar {
  margin: 8px 0;
}

.currency {
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.level {
  width: 100%;
  display: flex;
  align-items: center;
}

.progress-line {
  position: relative;
  height: 4px;
  width: 100%;
  background-color: "#FFFFFF80";
  border-radius: 2px;
  transform: scaleX(0);
}

.progress-line span {
  height: 100%;
  width: 80%;
  position: absolute;
  border-radius: 2px;
  transform: scaleX(0);
}
@keyframes animate {
  100% {
    transform: scaleX(1);
  }
}
.progress-line.last span {
  background-image: linear-gradient(127deg, #FFEE20 0%, #FFB715 16%, #FF1CBE 37%, #00C3FD 73%, #62FFE1 100%) !important;
  box-shadow: 1px 1px 6px rgba(255, 255, 255, 0.2431372549);
}

.overall_r {
  position: relative;
}

.overall_a {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/DougnutPieChart/index.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AAOA;EACI;IACI,oBAAA;EACN;AACF;AACA;EACI,qHAAA;EAMA,yDAAA;AAJJ;;AAMA;EACI,kBAAA;AAHJ;;AAKA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFJ","sourcesContent":[".skills-bar {\n    width: 100%;\n}\n\n.bar {\n    margin-top: 8px;\n}\n\n.bar_one {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.skills-box {\n    margin-top: 30px;\n}\n\n.skills-box .bar {\n    margin: 8px 0;\n}\n\n.currency {\n    width: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.level {\n    width: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.progress-line {\n    position: relative;\n    height: 4px;\n    width: 100%;\n    background-color: \"#FFFFFF80\";\n    border-radius: 2px;\n    transform: scaleX(0);\n}\n\n.progress-line span {\n    height: 100%;\n    width: 80%;\n    position: absolute;\n    border-radius: 2px;\n    transform: scaleX(0);\n}\n@-webkit-keyframes animate {\n    100% {\n        transform: scaleX(1);\n    }\n}\n\n@keyframes animate {\n    100% {\n        transform: scaleX(1);\n    }\n}\n.progress-line.last span {\n    background-image: linear-gradient(127deg,\n            #FFEE20 0%,\n            #FFB715 16%,\n            #FF1CBE 37%,\n            #00C3FD 73%,\n            #62FFE1 100%) !important;\n    box-shadow: 1px 1px 6px #FFFFFF3E;\n}\n.overall_r{\n    position:relative;\n}\n.overall_a{\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
